import React from 'react'

// Roughly the widths of the real tab labels so the bar does not jump on resolve.
const WIDTHS = [142, 123, 154, 150]

function ButtonSkeleton({ count = 3 }) {
    return (
        <div className="flex flex-row gap-[15px]" aria-hidden="true">
            {Array.from({ length: count }).map((_, idx) => (
                <div key={idx} className="dsh-skeleton-pill rounded-[10px] h-[60px]" style={{ width: WIDTHS[idx % WIDTHS.length] }} />
            ))}
        </div>
    )
}

export default ButtonSkeleton
